import { API_URL } from 'constants/environment';

export function redirectToDocs() {
  window.location.replace(`${API_URL}/docs`);
}
